export enum userTypes {
  GROUP = 'group',
  PROFILE = 'profile',
}
